export default "__VITE_ASSET__DWMhY4fe__"